class Router {
  constructor() {
    this._routes = [];
    this._route;
    this._params;
    this._fallback = () => null;
    this._history = [];
  }

  _onHashChange(evt) {
    let hash = location.hash;
    let route = this._routes.find((r) => r.pattern.test(hash));

    if (route !== this._route) {
      this._route = route;

      window.scrollTo(0, 0);
    }

    if (route) {
      this._history.unshift({ id: route.id, hash });

      let params = {};
      let matches = hash.match(route.pattern);

      this._params = params;

      route.tokens.forEach((token, i) => {
        let str = matches[i + 1];

        params[token.substr(1)] = str.match("=") ? this._decode(str) : decodeURI(str);
      });

      route.callback(params, route.route, route.id);

      return;
    }

    this._fallback();
  }

  _setHash(hash) {
    location.hash = hash;
  }

  _encode(obj) {
    let params = Object.keys(obj).map(function (key) {
      return encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]);
    });

    return params.join("&");
  }

  _decode(str) {
    let params = {};

    str.match("=") && str.split("&").map((param) => param.split("=")).forEach(function (args) {
      params[decodeURIComponent(args[0])] = decodeURIComponent(args[1]);
    });

    return params;
  }

  on(route, id, callback) {
    let _route = route.replace(/!\w+/g, "");

    this._routes.push({
      route: _route,
      id: id,
      callback: callback,
      tokens: _route.match(/\:\w+/g) || [],
      pattern: new RegExp("#" + _route.replace(/\:\w+/g, "([\\w\-\_\+\.%=&]+)") + "$")
    });
  }

  setFallback(fallback) {
    this._fallback = fallback;
  }

  start(initPath, redirect) {
    window.addEventListener("hashchange", this._onHashChange.bind(this));

    if (initPath && (redirect || location.hash === "")) {
      this._setHash(initPath);
    }

    this._onHashChange(null);
  }

  resolve(id, params = {}) {
    let route = this._routes.find((r) => r.id === id);

    if (route) {
      return "#" + route.route.replace(/\:\w+/g, (match) => {
        let param = params[match.substr(1)];
        return param && typeof param === "object" ? this._encode(param) : encodeURI(param);
      });
    }
  }

  trigger(id, params) {
    let hash = this.resolve(id, params);

    if (hash === location.hash) {
      this._onHashChange(null);
      return;
    }

    if (hash) {
      this._setHash(hash);
      return hash;
    }
  }

  id(hash) {
    let route = this._routes.find((r) => r.pattern.test(hash || location.hash));

    return route ? route.id : null;
  }

  params() {
    return this._params;
  }

  referrer() {
    let id = this.id();

    if (id) {
      let referrer = this._history.find(function (entry) {
        return entry.id !== id;
      });

      if (referrer) {
        return referrer;
      }
    }

    return null;
  }

  refresh(newParams) {
    this.trigger(this._route.id, { ...this._params, ...newParams });
  }
}


module.exports = Router;